import { ButtonStyle } from "../Button/Button.styles";

const Button = ({ onClick, title, leftIcon, rightIcon, style, disabled }) => {
  return (
    <>
      <ButtonStyle onClick={onClick} style={style} disabled={disabled}>
        {leftIcon}
        {title}
        {rightIcon}
      </ButtonStyle>
    </>
  );
};

export default Button;
